import React from "react";

const Stool = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M30 30 28 6l-2-4H10L8 6 6 30l-2 1.999v2h5.901l.526-6.005A2.185 2.185 0 0 1 12.604 26h10.718c1.136 0 2.083.87 2.178 2.003L25.999 34h6v-2.001l-1.999-2Zm-7.375-8h-9.29a2.185 2.185 0 0 1-2.176-2.376l.666-7.63A2.185 2.185 0 0 1 14.002 10h7.987c1.136 0 2.083.871 2.177 2.004l.636 7.629A2.185 2.185 0 0 1 22.625 22Z"
            fill={fill}
        />
    </svg>
);

export default Stool;
